import {
  Cell,
  ContextSelectorProps,
  ContextSelectorType,
  Tab,
  TableRow,
  buildContextSelectorRows,
} from '@ecosystem/newron-client-lib';

export const marketInfo = [
  {
    value: 'US-AIRCONDITIONING',
    label: 'Air Conditioning in United States',
    countryCode: 'US',
    countryName: 'United States',
    productCode: 'AIRCONDITIONING',
    productName: 'Air Conditioning',
    periods: [
      {
        sequence: 659,
        name: 'Nov 2024',
        periodicity: 'Monthly',
        published: '2024-12-18T09:36:02.000Z',
        value: 'Monthly:659',
      },
    ],
  },
  {
    value: 'CA-HEATING',
    label: 'Heating in Canada',
    countryCode: 'CA',
    countryName: 'Canada',
    productCode: 'HEATING',
    productName: 'Heating',
    periods: [
      {
        sequence: 660,
        name: 'Dec 2024',
        periodicity: 'Monthly',
        published: '2025-01-18T09:36:02.000Z',
        value: 'Monthly:660',
      },
    ],
  },
  {
    value: 'UK-VENTILATION',
    label: 'Ventilation in United Kingdom',
    countryCode: 'UK',
    countryName: 'United Kingdom',
    productCode: 'VENTILATION',
    productName: 'Ventilation',
    periods: [
      {
        sequence: 661,
        name: 'Jan 2025',
        periodicity: 'Monthly',
        published: '2025-02-18T09:36:02.000Z',
        value: 'Monthly:661',
      },
    ],
  },
  {
    value: 'IN-REFRIGERATION',
    label: 'Refrigeration in India',
    countryCode: 'IN',
    countryName: 'India',
    productCode: 'REFRIGERATION',
    productName: 'Refrigeration',
    periods: [
      {
        sequence: 662,
        name: 'Feb 2025',
        periodicity: 'Monthly',
        published: '2025-03-18T09:36:02.000Z',
        value: 'Monthly:662',
      },
    ],
  },
  {
    value: 'AU-HEATING',
    label: 'Heating in Australia',
    countryCode: 'AU',
    countryName: 'Australia',
    productCode: 'HEATING',
    productName: 'Heating',
    periods: [
      {
        sequence: 663,
        name: 'Mar 2025',
        periodicity: 'Monthly',
        published: '2025-04-18T09:36:02.000Z',
        value: 'Monthly:663',
      },
    ],
  },
] as Cell[];

const data: TableRow[] = buildContextSelectorRows(marketInfo);

const columnConfig = [
  { columnKey: 'productGroup', columnName: 'Product Group', isSortingEnabled: true },
  { columnKey: 'country', columnName: 'Country', isSortingEnabled: true },
  { columnKey: 'latestMonth', columnName: 'Latest Month', isSortingEnabled: true },
  { columnKey: 'latestWeek', columnName: 'Latest Week', isSortingEnabled: true },
];

const tabs: Tab[] = [
  {
    value: 'default',
    label: 'All markets',
    searchPlaceHolder: 'Search all markets',
  },
  {
    value: 'country',
    label: 'Countries',
    hasSeperator: true,
    showGroupedTablesByValue: true,
    searchPlaceHolder: 'Search product groups',
  },
  {
    value: 'productGroup',
    label: 'Product Groups',
    showGroupedTablesByValue: true,
    searchPlaceHolder: 'Search countries',
  },
];

export const contextSelectorData: ContextSelectorProps = {
  tableInfo: { data, columnConfig },
  triggerText: 'Select your market(s)',
  tabs,
  selectionSectionHeader: 'Selected markets',
  type: ContextSelectorType.Modal,
  onView: () => {
    // no-op
  },
};
